<template>
	<div id="app">
		
		<router-view />
		
		<div class="footer">
			<div class="footer-div">
				<!-- <p>版权所有:北京斗金汇通拍卖有限公司</p> -->
			</div>
		</div>
	</div>
</template>

<script>
	// import HelloWorld from './components/HelloWorld.vue'

	export default {
		name: 'app',
		// components: {
		//   HelloWorld
		// }
	}
</script>

<style>
	*{
		padding: 0;
		margin: 0;
	}
	
	.flex{
		display: -webkit-flex; /* Safari */
		display: -ms-flex; 
		display: -moz-flex; 
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.footer{
		width: 100%;
		/* height: 137px; */
		background: #0b0101;
	}
	.footer-div{
		width: 1250px;
		margin: 0 auto;
	}
</style>
